if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.form = document.getElementById(this.dataset.productFormId);
        this.button = this.querySelector('.sticky-atc-bar__button');
        this.watchTarget = document.querySelector(this.dataset.watchSelector);

        if (this.button && this.form) {
          this.button.addEventListener('click', () => {
            this.form.requestSubmit();
          });
        }

        if (this.watchTarget && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('sticky-atc-bar--visible', !entry.isIntersecting);
            });
          });
          this.observer.observe(this.watchTarget);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
